import { render, staticRenderFns } from "./AdministrativeUnitForm.vue?vue&type=template&id=7b1a97c4&"
import script from "./AdministrativeUnitForm.vue?vue&type=script&lang=js&"
export * from "./AdministrativeUnitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports